var m = require('mithril');
var prop = require('mithril/stream');
var pointTd = require('../data/components/pointTd');
var heading = require('../components/heading');
var heading = require('../components/heading');
var loaders = require('../layout/components/loaders');
var columnForm = require('../data/components/columnModal');
var Draggable = require('../libs/draggable');
var addColumnOnDataset = require('./libs/addColumnOnDataset');
var editColumnOnDataset = require('./libs/editColumnOnDataset');

function hasColumnValue(record, key) {
  return Object.prototype.hasOwnProperty.call(record || {}, key) &&
    record[key] !== null &&
    typeof record[key] !== 'undefined' &&
    record[key] !== '';
}

function getColumnBindingIndex(column, fallbackIndex) {
  if (hasColumnValue(column, 'index')) return column.index;
  if (hasColumnValue(column, 'id') && !Number.isNaN(Number(column.id))) return column.id;
  return fallbackIndex;
}

function displayColumnName(column) {
  return String((column && column.name) || '').trim();
}

function syncFromAttrs(ctrl, attrs) {
  attrs = attrs || {};
  ctrl.dashboardCallback = attrs.dashboardCallback;
  ctrl.fakeElement = attrs.element || {};
  ctrl.dataset = ctrl.fakeElement.out_Contains &&
    ctrl.fakeElement.out_Contains[0] &&
    ctrl.fakeElement.out_Contains[0].in ||
    {};
  ctrl.parentReinitialize = attrs.parentReinitialize;
  ctrl.limitOfColumns = attrs.numOfColumns ? attrs.numOfColumns : false;
}

function cloneColumns(columns) {
  return (Array.isArray(columns) ? columns : []).map(function (column) {
    return Object.assign({}, column);
  });
}

function waitForAllSettled(promises) {
  return Promise.all(promises.map(function (promise) {
    return Promise.resolve(promise)
      .then(function (value) { return { value: value }; })
      .catch(function (error) { return { error: error }; });
  }))
  .then(function (results) {
    var failed = results.find(function (result) { return result.error; });
    if (failed) throw failed.error;
    return results.map(function (result) { return result.value; });
  });
}

function refreshAfterFailedSort(ctrl) {
  return Promise.resolve()
    .then(function () { return ctrl.parentReinitialize(); })
    .catch(function (error) {
      console.error('Unable to reload dataset after a failed column reorder:', error);
      return null;
    });
}

function sortColumns(ctrl, draggableColumns) {
  if (ctrl.sorting()) return Promise.resolve(null);

  var names = draggableColumns.map(function (node) { return node.attributes.name.value; });
  var sortedColumns = cloneColumns(ctrl.dataset.columns)
    .sort(function (a, b) { return names.indexOf(a.name) - names.indexOf(b.name); })
    .map(function (column, index) {
      column.id = index;
      column.index = index;
      return column;
    });
  var columnsToUpdate = draggableColumns.map(function (node, index) {
    return {
      rid: node.attributes && node.attributes.rid && node.attributes.rid.value || null,
      index: index
    };
  });

  ctrl.sorting(true);
  ctrl.sortError('');
  return loaders.requestWithLoader({
    loader: 'background',
    method: 'PUT',
    url: '/api/v1/dataset/' + ctrl.dataset['@rid'].slice(1),
    body: {columns: sortedColumns}
  })
  .then(function () {
    return waitForAllSettled(columnsToUpdate.map(function (column) {
      if (!column.rid) return Promise.resolve();
      return loaders.requestWithLoader({
        loader: 'background',
        method: 'PUT',
        url: '/api/v1/column/' + column.rid.slice(1),
        body: {index: column.index}
      });
    }));
  })
  .then(function () {
    return ctrl.parentReinitialize();
  })
  .catch(function (error) {
    console.error('Unable to reorder dataset columns:', error);
    ctrl.sortError('Unable to reorder columns. The latest saved order was reloaded.');
    return refreshAfterFailedSort(ctrl).then(function () { return null; });
  })
  .then(function (result) {
    ctrl.sorting(false);
    m.redraw();
    return result;
  });
}

var oninit = function (vnode) {
  var ctrl = this;
  syncFromAttrs(ctrl, vnode.attrs);
  ctrl.sorting = prop(false);
  ctrl.sortError = prop('');

  ctrl.sortColumns = function (columns) {
    return sortColumns(ctrl, columns);
  };
  ctrl.sortOnIndex = (a,b) => {
    return (a.index || 0) - (b.index || 0);
  }

}

var onupdate = function(vnode) {
  syncFromAttrs(this, vnode.attrs);
}


var view = function(vnode) {
  var ctrl = this;
  return m('div.ba.bw1.pa2', [
      ctrl.sortError && ctrl.sortError() ?
        m('div.red.ba.b--red.pa2.mb2', { role: 'alert' }, [
          m('span', ctrl.sortError()),
          m('button.ml3', {
            type: 'button',
            onclick: ctrl.parentReinitialize
          }, 'Refresh')
        ])
        :
        '',
      m(heading, {
        label: ctrl.fakeElement.name, 
        class: 'f1', 
        element: ctrl.fakeElement, 
        parentReinitialize: ctrl.parentReinitialize, 
        dashboardCallback: ctrl.dashboardCallback,
        datasetRepresentation: true
      }),
      m('table.w-100', {style: {tableLayout: 'fixed'}}, [
        m(Draggable, {
          onsort: ctrl.sortColumns,
          disabled: ctrl.sorting && ctrl.sorting(),
          draggable: '.grid-column', 
          handleClass:'.grid-column-drag-handle', 
          htmlElement: 'tbody', 
          submitCallback: ctrl.parentReinitialize
        },[
          (ctrl.dataset.columns || []).sort(ctrl.sortOnIndex).map(function (column, jdx) {
            let findedColumn;
            let columnBindingIndex = getColumnBindingIndex(column, jdx);
            (ctrl.dataset.out_Column || []).forEach(columnEdgeRecord => {
              if (!findedColumn && hasColumnValue(columnEdgeRecord, 'index') && String(columnEdgeRecord.index) === String(columnBindingIndex)) {
                findedColumn = columnEdgeRecord;
                findedColumn.path = [
                  ...ctrl.dataset.path, 
                  {
                    name: findedColumn.name || findedColumn['@class'], 
                    '@rid': findedColumn['@rid']
                  }
                ];
              }
              if (!findedColumn && (
                displayColumnName(columnEdgeRecord) === displayColumnName(column) ||
                displayColumnName(columnEdgeRecord && columnEdgeRecord.in) === displayColumnName(column)
              )) {
                findedColumn = columnEdgeRecord;
                findedColumn.path = [
                  ...ctrl.dataset.path,
                  {
                    name: findedColumn.name || findedColumn['@class'],
                    '@rid': findedColumn['@rid']
                  }
                ];
              }
            })
            return m('tr.bb.grid-column', {
              key: `${column.id}_${column.name}`,
              name: column.name,
              paretDatasetRid: ctrl.dataset['@rid'],
              rid: findedColumn ? findedColumn['@rid'] : undefined
            },[
              m('td.f3.man.bb.tl.moon-gray.w-50.grid-column-drag-handle', [
                m(`div.blue.pointer`, {
                  onclick: editColumnOnDataset.bind(null, column, jdx, ctrl.dataset, findedColumn, ctrl)
                }, column.name || m('i.ion-ios-compose.blue')),
              ]),
              findedColumn ? 
                m(pointTd, {columnRecord: findedColumn, textAlign: 'center', parentReinitialize: ctrl.parentReinitialize}) 
              :
                m('td.bb.tc', {
                  onclick: columnForm.editDialogue.bind(columnForm, {out: ctrl.dataset['@rid'], index: columnBindingIndex, path: [...ctrl.dataset.path, {name: column.name, '@rid': 'NewCol'}]}, {columnName: column.name, delete: true, submitCallback: ctrl.parentReinitialize})
                }, [
                  m('i.ion-plus.blue')
                ]) 
            ])
          }),
          (() => {
            const isColumnLimitNotDefined = ctrl.limitOfColumns === false;
            const columnCountWithinLimit = isColumnLimitNotDefined 
              ? true // No limit, so it's always within the limit
              : (ctrl.dataset.columns || []).length + 1 <= ctrl.limitOfColumns;
            
            if (isColumnLimitNotDefined || columnCountWithinLimit) {
              return m('tr', [
                m('td.bb.bl-0.tc', [
                  addColumnOnDataset(ctrl)
                ])
              ]);
            } else {
              return '';
            }
            
          })()
        ])
      ])
    ])
  
}


module.exports = {
  oninit: oninit,
  onupdate: onupdate,
  view: view,
  _private: {
    cloneColumns: cloneColumns,
    sortColumns: sortColumns,
    waitForAllSettled: waitForAllSettled
  }
};
